module.exports = __webpack_public_path__ + "img/About_Us2.9e651e94.png";